import { render, staticRenderFns } from "./LegacyException.vue?vue&type=template&id=2a72a510&scoped=true&"
import script from "./LegacyException.vue?vue&type=script&lang=js&"
export * from "./LegacyException.vue?vue&type=script&lang=js&"
import style0 from "./LegacyException.vue?vue&type=style&index=0&id=2a72a510&prod&scoped=true&lang=css&"
import style1 from "./LegacyException.vue?vue&type=style&index=1&id=2a72a510&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72a510",
  null
  
)

export default component.exports